import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "defaultButton" }

import { ref } from 'vue';
import type { PropType } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'mainButton',
  props: {
    onClick: {
        type: Function as PropType<() => void>,
        required: false
    },
    title: {
        type: String,
        default: () => ''
    },
    activeStatus: {
        type: Boolean,
        default: false
    },
    radius: {
        type: String,
        default: () => ''
    },
    btnPadding: {
        type: String,
        default: () => ''
    },
    isBtnLoading: {
        type: Boolean,
        default: false
    },
    isColoured: {
        type: Boolean,
        default: false
    },
    forceGradientWhenDisabled: {
        type: Boolean,
        default: false
    }
},
  setup(__props) {

const props = __props


return (_ctx: any,_cache: any) => {
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.isBtnLoading)
      ? (_openBlock(), _createBlock(_component_van_button, {
          key: 0,
          disabled: "",
          style: _normalizeStyle({
            borderRadius: __props.radius ? __props.radius : '15px !important',
            padding: __props.btnPadding ? __props.btnPadding : '25px !important',
            background: '#000 !important'
        })
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.loading')), 1)
          ]),
          _: 1
        }, 8, ["style"]))
      : (_openBlock(), _createBlock(_component_van_button, {
          key: 1,
          disabled: !props.activeStatus,
          onClick: props.onClick,
          style: _normalizeStyle({
                borderRadius: __props.radius ? __props.radius : '15px',
                padding: __props.btnPadding ? __props.btnPadding : '25px',
                background: (!props.activeStatus && !props.forceGradientWhenDisabled)
                ? '#000'
                : 'linear-gradient(90deg, rgb(1, 73, 72) -18%, rgb(15, 177, 175) 122%)'
            })
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.title), 1)
          ]),
          _: 1
        }, 8, ["disabled", "onClick", "style"]))
  ]))
}
}

})